"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const look_up_module_1 = require("../../../../org-service/src/app/look-up/look-up.module");
const look_up_service_1 = require("../../../../org-service/src/app/look-up/look-up.service");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const meeting_controller_1 = require("./meeting.controller");
const meeting_repository_1 = require("./meeting.repository");
const meeting_service_1 = require("./meeting.service");
let MeetingModule = class MeetingModule {
};
exports.MeetingModule = MeetingModule;
exports.MeetingModule = MeetingModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                entities_1.Meeting,
                entities_1.MeetingParticipantMap,
                entities_1.LookUp,
                entities_1.OpportunityActivityMap,
                entities_1.Company,
                entities_1.Contact,
                entities_1.CompanyContactMap,
                entities_1.TpaContact,
                entities_1.InsureContact,
                entities_1.BrokerContact,
                entities_1.Employee,
                entities_1.Opportunity,
                entities_1.MeetingDocumentMap,
                entities_1.FileUpload,
            ]),
            jwt_1.JwtModule,
            look_up_module_1.LookUpModule,
        ],
        providers: [
            meeting_service_1.MeetingService,
            meeting_repository_1.MeetingRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            entity_service_utils_1.EntityService,
            look_up_service_1.LookUpService,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
        ],
        controllers: [meeting_controller_1.MeetingController],
        exports: [meeting_service_1.MeetingService, meeting_repository_1.MeetingRepository],
    })
], MeetingModule);
